const TruncateText = (text, maxlength) => {
  if (text && text.length > maxlength) {
    var newtext = text.slice(0, maxlength)
    newtext += "..."
    return newtext
  } else return text
}
export default TruncateText
